module.exports = __webpack_public_path__ + "fonts/92c5d4294031852d093dd5a87169c494.svg";